var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSolutionsBgShapeGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 352,
    height: 308,
    viewBox: "0 0 352 308",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2220_12252",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 352,
    height: 308
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M351.33 308H0V0.159973H351.33V308Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2220_12252)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M145.25 -118.2C77.1704 -134.4 8.85042 -92.3404 -7.34958 -24.2604C-17.9196 20.1696 -3.19958 67.9096 30.5204 98.7196C50.5104 116.98 72.8104 122.28 97.6304 131.3C172.85 158.66 258.36 207.15 272.91 293.68C277.19 319.11 304.69 273.72 308.71 266.85C388.41 130.71 329.25 -48.1004 181.48 -106.77C169.7 -111.45 157.58 -115.26 145.25 -118.2Z",
    stroke: "#217C4E",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.2 -109.14C81.2202 -124.6 16.0102 -84.4601 0.550248 -19.4801C-9.53975 22.9299 4.51025 68.4899 36.6902 97.8899C55.7702 115.32 77.0602 120.38 100.74 128.99C172.53 155.1 254.15 201.39 268.04 283.97C272.12 308.24 298.37 264.92 302.21 258.36C378.28 128.42 321.82 -42.2401 180.78 -98.2401C169.54 -102.7 157.97 -106.35 146.2 -109.15V-109.14Z",
    stroke: "#217C4E",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.15 -100.08C85.27 -114.8 23.17 -76.58 8.44998 -14.7C-1.16002 25.69 12.22 69.0799 42.87 97.0699C61.04 113.67 81.31 118.48 103.86 126.69C172.22 151.55 249.94 195.63 263.17 274.27C267.06 297.38 292.06 256.13 295.71 249.88C368.15 126.14 314.38 -36.37 180.07 -89.7C169.36 -93.95 158.34 -97.4201 147.14 -100.09L147.15 -100.08Z",
    stroke: "#217C4E",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.101 -91.0103C89.3208 -105 30.3408 -68.6903 16.3508 -9.91028C7.22078 28.4497 19.9308 69.6697 49.0408 96.2597C66.3008 112.02 85.5508 116.6 106.981 124.39C171.921 148.01 245.741 189.88 258.311 264.58C262.001 286.53 285.751 247.35 289.221 241.42C358.031 123.88 306.951 -30.4903 179.381 -81.1403C169.211 -85.1803 158.741 -88.4703 148.101 -91.0003V-91.0103Z",
    stroke: "#217C4E",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M149.06 -81.9502C93.3803 -95.2002 37.5103 -60.8102 24.2603 -5.13022C15.6103 31.2098 27.6503 70.2498 55.2303 95.4398C71.5803 110.37 89.8203 114.71 110.11 122.09C171.62 144.46 241.55 184.12 253.46 254.88C256.96 275.67 279.45 238.56 282.74 232.94C347.92 121.6 299.54 -24.6203 178.69 -72.6003C169.06 -76.4303 159.14 -79.5402 149.06 -81.9402V-81.9502Z",
    stroke: "#217C4E",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.01 -72.8902C97.4401 -85.4002 44.6701 -52.9202 32.1601 -0.350159C23.9901 33.9598 35.3601 70.8298 61.4001 94.6198C76.8401 108.72 94.0601 112.81 113.22 119.78C171.3 140.91 237.34 178.36 248.58 245.18C251.88 264.81 273.12 229.77 276.23 224.46C337.78 119.33 292.09 -18.7602 177.98 -64.0602C168.88 -67.6702 159.52 -70.6202 150 -72.8802L150.01 -72.8902Z",
    stroke: "#217C4E",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.961 -63.83C101.491 -75.6 51.8407 -45.04 40.0607 4.42996C32.3807 36.72 43.0707 71.41 67.5807 93.8C82.1107 107.07 98.3107 110.92 116.351 117.48C171.011 137.36 233.151 172.6 243.731 235.48C246.841 253.96 266.831 220.97 269.751 215.98C327.671 117.05 284.681 -12.89 177.291 -55.5201C168.731 -58.9201 159.921 -61.69 150.961 -63.82V-63.83Z",
    stroke: "#217C4E",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.91 -54.7607C105.54 -65.7907 59.0002 -37.1507 47.9702 9.21928C40.7702 39.4893 50.8002 71.9993 73.7602 92.9793C87.3802 105.419 102.57 109.029 119.47 115.169C170.7 133.799 228.95 166.839 238.86 225.769C241.77 243.089 260.51 212.169 263.25 207.489C317.54 114.759 277.24 -7.0307 176.59 -47.0007C168.57 -50.1907 160.31 -52.7807 151.91 -54.7807V-54.7607Z",
    stroke: "#217C4E",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.86 -45.7C109.59 -56 66.1599 -29.27 55.8699 14C49.1499 42.24 58.51 72.58 79.94 92.16C92.64 103.77 106.82 107.13 122.59 112.87C170.4 130.26 224.75 161.08 234 216.08C236.72 232.24 254.2 203.39 256.76 199.03C307.42 112.5 269.82 -1.15 175.9 -38.44C168.41 -41.41 160.71 -43.84 152.87 -45.7H152.86Z",
    stroke: "#217C4E",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.821 -36.6402C113.651 -46.2002 73.3405 -21.3802 63.7805 18.7898C57.5405 45.0098 66.2305 73.1798 86.1205 91.3498C97.9105 102.12 111.071 105.25 125.721 110.58C170.101 126.72 220.561 155.34 229.141 206.39C231.661 221.39 247.891 194.61 250.271 190.56C297.291 110.23 262.391 4.72982 175.201 -29.8902C168.251 -32.6502 161.101 -34.9002 153.821 -36.6302V-36.6402Z",
    stroke: "#217C4E",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolutionsBgShapeGreen);
export default __webpack_public_path__ + "static/media/solutions_bg_shape_green.0a264337b6f8c57d01ee1d79196145ff.svg";
export { ForwardRef as ReactComponent };